import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD3KeSsMkgpsGixhnbG5IHyaw4QNqhKDwM",
  authDomain: "reebuk-health-inc.firebaseapp.com",
  projectId: "reebuk-health-inc",
  storageBucket: "reebuk-health-inc.firebasestorage.app",
  messagingSenderId: "1053871392846",
  appId: "1:1053871392846:web:351fed738721eeed58db1f",
  measurementId: "G-EDBKGZ8ESP",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth();

export { app, db, auth, storage };
